export const entitiesColums = [
  {
    name: "Nombre",
    selector: (row) => row["name"],
    sortable: true,
    center: false,
  },
  {
    name: "Tipo",
    selector: (row) => row["type"],
    sortable: true,
    center: true,
  },
];
